<div *ngIf="data" class="widget-container">
  <div class="header" (click)="headerAction()">
    {{ data.title }}
  </div>
  <div class="loading-content" *ngIf="!chartData">
    <lib-loading></lib-loading>
  </div>
  <div *ngIf="chartData" class="chart-container">
    <div class="chart-content" (click)="iconAction(0)">
      <canvas id="greenChart" baseChart 
        [data]="doughnutChartDataA"
        [labels]="doughnutChartLabelA"
        [colors]="doughnutChartColorA"
        [options]="doughnutChartOptions"
        [chartType]="doughnutChartType">
      </canvas>
      <span>{{ doughnutChartDataA[0] < 10 ? '0' : '' }}{{ doughnutChartDataA[0] || '0' }}</span>
    </div>
    <div class="chart-content" (click)="iconAction(1)">
      <canvas id="yellowChart" baseChart 
        [data]="doughnutChartDataB"
        [labels]="doughnutChartLabelB"
        [colors]="doughnutChartColorB"
        [options]="doughnutChartOptions"
        [chartType]="doughnutChartType">
      </canvas>
      <span>{{ doughnutChartDataB[0] < 10 ? '0' : '' }}{{ doughnutChartDataB[0] || '0' }}</span>
    </div>
    <div class="chart-content" (click)="iconAction(2)">
      <canvas id="redChart" baseChart 
        [data]="doughnutChartDataC"
        [labels]="doughnutChartLabelC"
        [colors]="doughnutChartColorC"
        [options]="doughnutChartOptions"
        [chartType]="doughnutChartType">
      </canvas>
      <span>{{ doughnutChartDataC[0] < 10 ? '0' : '' }}{{ doughnutChartDataC[0] || '0' }}</span>
    </div>
  </div>
</div>